module.exports = __webpack_public_path__ + "static/media/hakkimizda-image.454f8438.png";